// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.ses-split {
  display: inline-block;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: #f1f1f2;
  color: #6d6e71;
  border: 1px solid #e7eaec;
}

.ses-status {
  display: inline-block;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.ses-status--active {
  background: #eef8e4;
  color: #4a8c1c;
}
.ses-status--expired {
  background: #fde7ea;
  color: #f54359;
}

.ses-avatar {
  display: inline-flex;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #6d6e71;
  color: #fff;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}
.ses-avatar--grey {
  background: #e7eaec;
  color: #6d6e71;
}

.sesl {
  padding: 32px 48px 48px;
  max-width: 1400px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 991px) {
  .sesl {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .sesl {
    padding: 16px 16px 28px;
  }
}

.sesl-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
}
@media (max-width: 640px) {
  .sesl-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
}
.sesl-header__left {
  flex: 1;
}
.sesl-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sesl-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .sesl-header__title {
    font-size: 22px;
  }
}

.sesl-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.sesl-breadcrumb li {
  display: flex;
  align-items: center;
}
.sesl-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.sesl-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.sesl-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.sesl-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.sesl-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .sesl-toolbar {
    gap: 10px;
    padding: 12px 16px;
  }
}
@media (max-width: 640px) {
  .sesl-toolbar .sesl-searchbar {
    flex-basis: 100%;
    max-width: none;
  }
}

.sesl-searchbar {
  display: flex;
  align-items: center;
  flex: 1 1 420px;
  max-width: 620px;
  min-width: 0;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.sesl-searchbar:focus-within {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.sesl-searchbar__icon {
  padding: 0 8px 0 14px;
  color: #ccc;
  font-size: 13px;
}
.sesl-searchbar__input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 10px 8px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
}
.sesl-searchbar__input::placeholder {
  color: #ccc;
}
.sesl-searchbar__clear {
  flex: 0 0 auto;
  background: #ccc;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  margin-right: 6px;
  transition: background 0.15s ease;
}
.sesl-searchbar__clear:hover {
  background: #676a6c;
}
.sesl-searchbar__divider {
  width: 1px;
  align-self: stretch;
  background: #e7eaec;
  margin: 7px 0;
}
.sesl-searchbar__select {
  position: relative;
  display: flex;
  align-items: center;
  transition: background 0.15s ease;
}
.sesl-searchbar__select:hover {
  background: #f1f1f2;
}
.sesl-searchbar__field {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  padding: 10px 34px 10px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
}
.sesl-searchbar__caret {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 14px;
  pointer-events: none;
}

.sesl-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
  line-height: 1.4;
}
.sesl-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.sesl-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}

.sesl-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  min-height: 200px;
}
.sesl-content .table-responsive {
  overflow-x: auto;
}
.sesl-content table {
  width: 100%;
  margin-bottom: 0;
  border-collapse: collapse;
}
.sesl-content table thead tr {
  background: #f1f1f2;
}
.sesl-content table thead tr th {
  padding: 9px 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  border-top: none;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: default;
}
.sesl-content table thead tr th.cursor-pointer {
  cursor: pointer;
}
.sesl-content table thead tr th.cursor-pointer:hover {
  color: rgb(0, 173, 208);
}
.sesl-content table thead tr th.cursor-pointer i {
  margin-left: 4px;
  font-size: 12px;
}
.sesl-content table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
  cursor: pointer;
}
.sesl-content table tbody tr:hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.sesl-content table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.sesl-content table tbody tr:nth-of-type(even):hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.sesl-content table tbody tr td {
  padding: 8px 10px;
  font-size: 12px;
  color: #676a6c;
  vertical-align: middle;
  border-top: none;
}
.sesl-content table tbody tr td a:not(.sesl-actions__opr) {
  color: #676a6c;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}
.sesl-content table tbody tr td a:not(.sesl-actions__opr):hover {
  color: rgb(0, 173, 208);
}
.sesl-content table tbody tr td a.sesl-namelink {
  font-weight: 700;
}

.sesl-count {
  text-align: center;
}

.sesl-namelink {
  color: #676a6c !important;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.15s ease;
}
.sesl-namelink:hover {
  color: rgb(0, 173, 208) !important;
}

.sesl-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.sesl-actions__opr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  background: transparent;
  color: #9aa0a6;
  border-color: #e7eaec;
}
.sesl-actions__opr--edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  transform: scale(1.08);
}
.sesl-actions__opr--copy:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
  transform: scale(1.08);
}
.sesl-actions__opr--delete:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(245, 67, 89, 0.3);
}

.sesl-actions-col {
  width: 120px;
}

.sesl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.sesl-state > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.sesl-state p {
  font-size: 15px;
  color: #ccc;
  margin: 0;
}

.sesl-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e7eaec;
  flex-wrap: wrap;
}
.sesl-pager__info {
  font-size: 12px;
  color: #ccc;
}
.sesl-pager__ctrls {
  display: flex;
  gap: 4px;
}
.sesl-pager__btn {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.sesl-pager__btn:hover:not(:disabled):not(.is-active) {
  background: #f1f1f2;
  border-color: #ccc;
}
.sesl-pager__btn.is-active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
.sesl-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sesl-pager__left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.sesl-perpage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: #ccc;
}
.sesl-perpage select {
  padding: 4px 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  color: #676a6c;
  cursor: pointer;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/sessions/list/sessions-list.component.scss","webpack://./src/app/components/sessions/_ses-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;ACtxBA;EACE,qBAAA;EAAuB,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAChF,mBAAA;EAAqB,mBFgCD;EEhCmC,cF6BpC;EE5BnB,yBAAA;AD+xBF;;AC3xBA;EACE,qBAAA;EAAuB,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAChF,mBAAA;ADkyBF;ACjyBE;EAAY,mBAAA;EAAqB,cAAA;ADqyBnC;ACpyBE;EAAa,mBAAA;EAAqB,cAAA;ADwyBpC;;ACryBA;EACE,oBAAA;EAAsB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBFgBlD;EEfnB,WAAA;EAAa,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,gBAAA;EAAkB,cAAA;ADizB/F;AC7yBE;EAAU,mBFoBG;EEpBwB,cFWlB;ACsyBrB;;AAp0BA;EACE,uBAAA;EACA,iBAAA;EACA,wEDbW;ACo1Bb;AAr0BE;EALF;IAK8B,uBAAA;EAy0B5B;AACF;AAz0BE;EANF;IAM8B,uBAAA;EA60B5B;AACF;;AA10BA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA60BF;AA30BE;EAPF;IAO8B,sBAAA;IAAwB,uBAAA;IAAyB,mBAAA;EAi1B7E;AACF;AAh1BE;EAAU,OAAA;AAm1BZ;AAl1BE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAu1BrD;AAr1BE;EACE,eAAA;EACA,gBAAA;EACA,cDKiB;ECJjB,SAAA;EACA,uBAAA;EACA,wEDtCS;ECuCT,gBAAA;AAu1BJ;AAr1BI;EATF;IAS8B,eAAA;EAy1B9B;AACF;;AAr1BA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDXkB;ACm2BpB;AAt1BE;EACE,aAAA;EACA,mBAAA;AAw1BJ;AAt1BI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDjBzC;ECiBoE,eAAA;AA41BxF;AA11BI;EACE,cD3Be;EC4Bf,qBAAA;EACA,4BAAA;AA41BN;AA31BM;EAAU,uBD5CA;AC04BhB;AA11BE;EAAa,cD7BM;EC6BsB,gBAAA;AA81B3C;;AA11BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBDrCoB;ECsCpB,kBAAA;EACA,yBAAA;AA61BF;AA31BE;EAXF;IAW8B,SAAA;IAAW,kBAAA;EAg2BvC;AACF;AAh2BE;EACE;IAAkB,gBAAA;IAAkB,eAAA;EAo2BtC;AACF;;AAh2BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AAm2BF;AAj2BE;EAAiB,8BDlFH;ECkFiC,4CAAA;AAq2BjD;AAn2BE;EAAU,qBAAA;EAAuB,WD/Df;EC+D0C,eAAA;AAw2B9D;AAt2BE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,wEDnHS;ECoHT,cDjFiB;ACy7BrB;AAt2BI;EAAiB,WD5ED;ACq7BpB;AAt2BE;EACE,cAAA;EACA,gBDjFgB;ECkFhB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,iCAAA;AAw2BJ;AAv2BI;EAAU,mBDtGO;ACg9BrB;AAv2BE;EAAa,UAAA;EAAY,mBAAA;EAAqB,mBD3FjC;EC2F4D,aAAA;AA62B3E;AA32BE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;AA62BJ;AA52BI;EAAU,mBDxGQ;ACu9BtB;AA52BE;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDjKS;ECkKT,cD/HiB;AC6+BrB;AA32BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WDhIgB;ECiIhB,eAAA;EACA,oBAAA;AA62BJ;;AAx2BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED1LW;EC2LX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AA22BF;AAz2BE;EACE,6BD3KY;EC4KZ,WAAA;EACA,+BD7KY;ACwhChB;AA12BI;EAAU,mBDxJK;ECwJ0B,qBDxJ1B;ACsgCnB;;AAz2BA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AA42BF;AA12BE;EAAoB,gBAAA;AA62BtB;AA32BE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AA62BJ;AA32BI;EACE,mBD9KgB;AC2hCtB;AA32BM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDzLa;EC0Lb,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wEDrOK;ECsOL,eAAA;AA62BR;AA32BQ;EACE,eAAA;AA62BV;AA52BU;EAAU,uBDrNJ;ACokChB;AA92BU;EAAI,gBAAA;EAAkB,eAAA;AAk3BhC;AA72BI;EACE,uCAAA;EACA,gCAAA;EACA,eAAA;AA+2BN;AA72BM;EAAU,yCAAA;AAg3BhB;AA/2BM;EACE,0CAAA;AAi3BR;AAh3BQ;EAAU,yCAAA;AAm3BlB;AAh3BM;EACE,iBAAA;EACA,eAAA;EACA,cD3Na;EC4Nb,sBAAA;EACA,gBAAA;AAk3BR;AAh3BQ;EACE,cDhOW;ECiOX,qBAAA;EACA,gBAAA;EACA,4BAAA;AAk3BV;AAj3BU;EAAU,uBDlPJ;ACsmChB;AAl3BQ;EAAkB,gBAAA;AAq3B1B;;AA/2BA;EAAc,kBAAA;AAm3Bd;;AAh3BA;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;AAm3BF;AAl3BE;EAAU,kCAAA;AAq3BZ;;AAj3BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAo3BF;AAl3BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EAEA,uBAAA;EACA,cAAA;EACA,qBDjQW;AConCf;AAj3BI;EAAgB,4BD/RJ;EC+RgC,WAAA;EAAa,8BD/R7C;EC+R2E,sBAAA;AAu3B3F;AAt3BI;EAAgB,6BD9RJ;EC8RgC,WAAA;EAAa,+BD9R7C;EC8R2E,sBAAA;AA43B3F;AA33BI;EAAkB,4BD9RJ;EC8RkC,WAAA;EAAa,8BD9R/C;EC8R+E,sBAAA;EAAwB,4CAAA;AAk4BzH;;AA/3BA;EAAoB,YAAA;AAm4BpB;;AAh4BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAm4BF;AAj4BE;EAAQ,eAAA;EAAiB,mBAAA;EAAqB,WD1R5B;ACgqCpB;AAr4BE;EAAI,eAAA;EAAiB,WD3RH;EC2R8B,SAAA;AA04BlD;;AAt4BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAy4BF;AAv4BE;EAAU,eAAA;EAAiB,WDxST;ACmrCpB;AA14BE;EAAW,aAAA;EAAe,QAAA;AA84B5B;AA74BE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cDxTiB;ECyTjB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AA+4BJ;AA74BI;EAAyC,mBDtTvB;ECsTyD,kBDvT3D;ACwsCpB;AAh5BI;EAAc,mBD1TG;EC0T8B,WAAA;EAAa,qBD1T3C;AC+sCrB;AAp5BI;EAAa,YAAA;EAAc,mBAAA;AAw5B/B;;AAr5BA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AA45BnE;;AA35BA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,eAAA;EAAiB,WD9T/D;ACiuCpB;AAl6BE;EAAS,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,cDtU9E;ECsU0G,eAAA;EAAiB,aAAA;AA26BhJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n@import \"../_ses-shared\";\n\n// ─────────────────────────────────────────────\n// Sessions listing — mirrors the Reports listing chrome exactly.\n// Only the class prefix (sesl-) and the session-specific cells (.ses-split,\n// .ses-status, .ses-avatar in _ses-shared; .sesl-count here) differ. Every\n// spacing, colour and state below is kept in lock-step with\n// reports-list.component.scss so the two pages read as one system.\n// ─────────────────────────────────────────────\n\n.sesl {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n  font-family: $font-stack;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// ── Header ───────────────────────\n.sesl-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; margin-bottom: 20px; }\n\n  &__left { flex: 1; }\n  &__title-row { display: flex; align-items: center; gap: 12px; }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n}\n\n// ── Breadcrumb ───────────────────────\n.sesl-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n      &:hover { color: $clarify-color; }\n    }\n  }\n\n  &__current { color: $color-neutral-dark; font-weight: 600; }\n}\n\n// ── Toolbar (grey panel) ───────────────────────\n.sesl-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n  padding: 14px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) { gap: 10px; padding: 12px 16px; }\n  @media (max-width: 640px) {\n    .sesl-searchbar { flex-basis: 100%; max-width: none; }\n  }\n}\n\n// Combined search + type filter — one bordered unit\n.sesl-searchbar {\n  display: flex;\n  align-items: center;\n  flex: 1 1 420px;\n  max-width: 620px;\n  min-width: 0;\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:focus-within { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n\n  &__icon { padding: 0 8px 0 14px; color: $color-neutral-mid; font-size: 13px; }\n\n  &__input {\n    flex: 1;\n    min-width: 0;\n    border: none;\n    outline: none;\n    background: transparent;\n    padding: 10px 8px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n\n    &::placeholder { color: $color-neutral-mid; }\n  }\n\n  &__clear {\n    flex: 0 0 auto;\n    background: $color-neutral-mid;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 10px;\n    padding: 0;\n    margin-right: 6px;\n    transition: background 0.15s ease;\n    &:hover { background: $body-content-color; }\n  }\n\n  &__divider { width: 1px; align-self: stretch; background: $color-grey-1; margin: 7px 0; }\n\n  &__select {\n    position: relative;\n    display: flex;\n    align-items: center;\n    transition: background 0.15s ease;\n    &:hover { background: $color-neutral-light; }\n  }\n\n  &__field {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: none;\n    outline: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 10px 34px 10px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $body-content-color;\n  }\n\n  &__caret {\n    position: absolute;\n    right: 13px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: $color-neutral-mid;\n    font-size: 14px;\n    pointer-events: none;\n  }\n}\n\n// ── Primary button ───────────────────────\n.sesl-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n  line-height: 1.4;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n    &:hover { background: $color-dark-green; border-color: $color-dark-green; }\n  }\n}\n\n// ── Content card ───────────────────────\n.sesl-content {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  min-height: 200px;\n\n  .table-responsive { overflow-x: auto; }\n\n  table {\n    width: 100%;\n    margin-bottom: 0;\n    border-collapse: collapse;\n\n    thead tr {\n      background: $color-neutral-light;\n\n      th {\n        padding: 9px 10px;\n        font-size: 10px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n        border-bottom: 2px solid $color-grey-1;\n        border-top: none;\n        white-space: nowrap;\n        font-family: $font-stack;\n        cursor: default;\n\n        &.cursor-pointer {\n          cursor: pointer;\n          &:hover { color: $clarify-color; }\n          i { margin-left: 4px; font-size: 12px; }\n        }\n      }\n    }\n\n    tbody tr {\n      transition: background-color 0.12s ease;\n      border-bottom: 1px solid $color-grey-1;\n      cursor: pointer;\n\n      &:hover { background-color: rgba($clarify-color, 0.03); }\n      &:nth-of-type(even) {\n        background-color: rgba($color-neutral-light, 0.5);\n        &:hover { background-color: rgba($clarify-color, 0.03); }\n      }\n\n      td {\n        padding: 8px 10px;\n        font-size: 12px;\n        color: $body-content-color;\n        vertical-align: middle;\n        border-top: none;\n\n        a:not(.sesl-actions__opr) {\n          color: $body-content-color;\n          text-decoration: none;\n          font-weight: 500;\n          transition: color 0.15s ease;\n          &:hover { color: $clarify-color; }\n        }\n        a.sesl-namelink { font-weight: 700; }\n      }\n    }\n  }\n}\n\n.sesl-count { text-align: center; }\n\n// Name link — grey at rest, Clarify blue on hover.\n.sesl-namelink {\n  color: $body-content-color !important;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  &:hover { color: $clarify-color !important; }\n}\n\n// ── Action buttons — grey at rest, filled colour on hover (matches Invitations) ──\n.sesl-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n\n  &__opr {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border-radius: 6px;\n    font-size: 13px;\n    line-height: 1;\n    border: 1px solid transparent;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.2s ease;\n\n    background: transparent;\n    color: #9aa0a6;\n    border-color: $color-grey-1;\n\n    &--edit:hover { background: $clarify-color; color: #fff; border-color: $clarify-color; transform: scale(1.08); }\n    &--copy:hover { background: $develop-color; color: #fff; border-color: $develop-color; transform: scale(1.08); }\n    &--delete:hover { background: $implement-color; color: #fff; border-color: $implement-color; transform: scale(1.08); box-shadow: 0 2px 8px rgba($implement-color, 0.3); }\n  }\n}\n.sesl-actions-col { width: 120px; }\n\n// ── Empty state ───────────────────────\n.sesl-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i { font-size: 36px; margin-bottom: 16px; color: $color-neutral-mid; }\n  p { font-size: 15px; color: $color-neutral-mid; margin: 0; }\n}\n\n// ── Pager ───────────────────────\n.sesl-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid $color-grey-1;\n  flex-wrap: wrap;\n\n  &__info { font-size: 12px; color: $color-neutral-mid; }\n  &__ctrls { display: flex; gap: 4px; }\n  &__btn {\n    min-width: 30px;\n    height: 30px;\n    padding: 0 8px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    background: #fff;\n    color: $body-content-color;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover:not(:disabled):not(.is-active) { background: $color-neutral-light; border-color: $color-neutral-mid; }\n    &.is-active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n    &:disabled { opacity: 0.4; cursor: not-allowed; }\n  }\n}\n.sesl-pager__left { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n.sesl-perpage {\n  display: inline-flex; align-items: center; gap: 6px; margin: 0; font-size: 12px; color: $color-neutral-mid;\n  select { padding: 4px 8px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 12px; color: $body-content-color; cursor: pointer; outline: none; }\n}\n","// Session chrome shared by the listing and (later) the board/wizard.\n//\n// A partial, not classes borrowed from another component: Angular injects a component's styles\n// only when that component first instantiates, so anything defined in sessions-list.component.scss\n// simply does not exist on /sessions/new. This is the same trap _inv-form.scss (Invitations) and\n// _rep-shared.scss (Reports) were extracted to solve.\n\n@import \"../../../assets/styles/variables\";\n\n// Split-type pill — neutral grey; the label always spells the split strategy out.\n.ses-split {\n  display: inline-block; border-radius: 10px; padding: 3px 10px; font-size: 11px; font-weight: 600;\n  white-space: nowrap; background: $color-neutral-light; color: $color-neutral-dark;\n  border: 1px solid $color-grey-1;\n}\n\n// Status pill — active vs. expired. Colour is never the only signal — the label spells it out too.\n.ses-status {\n  display: inline-block; border-radius: 10px; padding: 3px 10px; font-size: 11px; font-weight: 600;\n  white-space: nowrap;\n  &--active { background: #eef8e4; color: #4a8c1c; }    // Develop tint\n  &--expired { background: #fde7ea; color: #f54359; }   // Implement tint\n}\n\n.ses-avatar {\n  display: inline-flex; width: 26px; height: 26px; border-radius: 50%; background: $color-neutral-dark;\n  color: #fff; align-items: center; justify-content: center; font-size: 9px; font-weight: 700; flex-shrink: 0;\n\n  // Listing avatars are neutral, matching Reports/Invitations \"Organizer\" column: the creator is\n  // context, not a status signal, so it must not read as loud as the split/status pills beside it.\n  &--grey { background: $color-grey-1; color: $color-neutral-dark; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
